@let current = selectedItem();
<div class="sir-container" #container tabindex="-1" (blur)="onBlur($event)">
    <div class="sir-menu-top">
        @if (current.submenuParent) {
            <sirius-icon [name]="'caret_left'" (click)="previous()"></sirius-icon>
        }
        @if (current.submenuLink; as submenuLink) {
            <a href="" class="sir-menu-title sir-text-style-paragraph-l-bold" [siriusLink]="submenuLink" (linkSelect)="onClick($event, submenuLink)">
                {{ current.submenuTitle }}
            </a>
        } @else {
            <h2 class="sir-menu-title sir-text-style-paragraph-l-bold">{{ current.submenuTitle }}</h2>
        }
        <sirius-icon [name]="'x'" (click)="closeMenu()"></sirius-icon>
    </div>
    <div class="sir-menu-body sir-text-style-paragraph-s-bold">
        <ul>
            @for (item of current.submenuItems; track $index) {
                <li class="sir-nav-item">
                    <sirius-sidebar-item
                        [isParent]="isItemParent(item)"
                        [title]="item.submenuTitle"
                        [subtitle]="item.submenuSubtitle"
                        [link]="item.submenuLink"
                        [icon]="item.submenuIcon"
                        [active]="item.submenuActive"
                        (leafClicked)="onClick($event, item.submenuLink)"
                        (itemClicked)="next($index)"></sirius-sidebar-item>
                </li>
            }
        </ul>
    </div>
</div>
<sirius-dimmer [focusElement]="container"></sirius-dimmer>
